import React from 'react';
import { useSelector } from 'react-redux';
import BaseSidebar, { MenuIconType } from '@copilot/common/components/menus/sidebar';
import { OrganizationMemberSelectors } from '@copilot/common/store/selectors/organizationMember';
import { Config } from '@copilot/common/config';
import { useLocation } from 'react-router';

export const MenuKeys = {
    Root: '/',
    Categorize: '/categorize',
};

const MenuItems: () => React.ComponentProps<typeof BaseSidebar>['menuItems'] = () => {
    const items = [];

    if (!Config.hideCSTeamsDash) {
        items.push({
            key: MenuKeys.Root,
            to: MenuKeys.Root,
            icon: MenuIconType.TeamOutlined,
            label: 'Team Customers',
        });
    }

    return items;
};

const Sidebar: React.FC = () => {
    const location = useLocation();
    const pathname = React.useMemo(() => {
        const pathSplit = location.pathname.split('/');
        if (!pathSplit[1]) return '/';
        else return location.pathname;
    }, [location.pathname]);
    const activeMember = useSelector(OrganizationMemberSelectors.getActiveMember);
    if (!activeMember) return <span />;
    return (
        <BaseSidebar
            menuOptions={{
                mode: 'inline',
                theme: Config.isAgency ? 'light' : 'dark',
                selectedKeys: [pathname],
            }}
            menuItems={MenuItems()}
        />
    );
};
export default Sidebar;
